var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"touchmove":_vm.handleTouch}},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.LOADING),expression:"LOADING"}]}),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":"","leave":""}},[_c('router-view',{ref:"router"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }